import React from "react";

const TotalContext=React.createContext();

export default TotalContext;